import { render, staticRenderFns } from "./PatientOverviewCard.vue?vue&type=template&id=f8d0328a&"
import script from "./PatientOverviewCard.vue?vue&type=script&lang=js&"
export * from "./PatientOverviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports